<ng-container *ngIf="isJobSuspended; else detailsOnlyTmpl">
    <mat-tab-group #tabGroup
                   matDialogTitle
                   dynamicHeight="true"
                   class="tab-header">
        <mat-tab #detailsTab
                 [label]="'job_details_modal_title' | translate ">
        </mat-tab>
        <mat-tab #triggersTab
                 [label]="'job_details_triggers' | translate">
        </mat-tab>
    </mat-tab-group>
    <mat-dialog-content class="job-details">
        <ng-container *ngIf="detailsTab.isActive">
            <ng-container *ngTemplateOutlet="detailTmpl"></ng-container>
        </ng-container>
        <ng-container *ngIf="isJobSuspended">
            <ng-container *ngTemplateOutlet="triggersTmpl; context: { $implicit: triggersTab }"></ng-container>
        </ng-container>
    </mat-dialog-content>
</ng-container>

<ng-template #detailsOnlyTmpl>
    <h1 translate
        matDialogTitle>
        job_details_modal_title
    </h1>
    <mat-dialog-content class="job-details">
        <ng-container *ngTemplateOutlet="detailTmpl"></ng-container>
    </mat-dialog-content>
</ng-template>

<mat-dialog-actions align="end">
    <button mat-dialog-close
            mat-button
            type="button">
        {{ 'modal_action_close' | translate }}
    </button>
</mat-dialog-actions>

<ng-template #detailTmpl>
    <ul class="no-bullets">
        <li>
            <span class="job-detail-property">
                {{ 'job_details_modal_process' | translate }}:
            </span>
            {{ context?.data?.release?.processKey }}
        </li>
        <li>
            <span class="job-detail-property">
                {{ 'job_details_modal_environment' | translate }}:
            </span>
            {{ context.data.environmentName }}
        </li>
        <li>
            <span class="job-detail-property">
                {{ 'job_details_modal_robot' | translate }}:
            </span>
            {{ context?.data?.robot?.name }}
        </li>
        <li *ngIf="context?.data?.hostMachineName">
            <span class="job-detail-property">
                {{ 'job_details_modal_host_machine_name' | translate }}:
            </span>
            {{ context?.data?.hostMachineName }}
        </li>
        <li>
            <span class="job-detail-property">
                {{ 'job_details_modal_info' | translate }}:
            </span>
            <span *ngIf="context.data.info"
                  [innerHTML]="context.data.info | nl2br">
            </span>
        </li>
        <li>
            <span class="job-detail-property">
                {{ 'job_details_modal_start_time' | translate }}:
            </span>
            <span *ngIf="context.data.startTime"
                  [date]="context.data.startTime"
                  uiDateFormat></span>
        </li>
        <li>
            <span class="job-detail-property">
                {{ 'job_details_modal_end_time' | translate }}:
            </span>
            <span *ngIf="context.data.endTime"
                  [date]="context.data.endTime"
                  uiDateFormat></span>
        </li>
        <li>
            <ui-json-formatter [data]="context?.data?.inputArguments"
                               [levelsOpen]="2"
                               [key]="'parameter_collection_process_type_input' | translate"
                               [objectPlaceholder]="'global_json_object_placeholder' | translate"
                               [emptyPlaceholder]="'global_json_empty_placeholder' | translate">
            </ui-json-formatter>
            <ui-json-formatter [data]="context?.data?.outputArguments"
                               [levelsOpen]="2"
                               [key]="'parameter_collection_process_type_output' | translate"
                               [objectPlaceholder]="'global_json_object_placeholder' | translate"
                               [emptyPlaceholder]="'global_json_empty_placeholder' | translate">
            </ui-json-formatter>
        </li>
        <li>
            <span class="job-detail-property">
                {{ 'job_details_modal_recording' | translate }}:
            </span>
            {{ context.data.hasMediaRecorded }}
        </li>
    </ul>
</ng-template>

<ng-template #triggersTmpl
             let-tab>
    <ui-job-triggers-grid [hidden]="!tab.isActive"
                          [jobId]="context?.data?.id">
    </ui-job-triggers-grid>
</ng-template>
